<div [hidden]="selectedPrice">
    <tarifications-list
            *ngIf="displayListOrTable === displayTarificationsListType"
            [priceArray]="booking.priceArray"
            [costOrRetail]="costOrRetail"
            [booking]="booking">
    </tarifications-list>
    <prices-table
            *ngIf="displayListOrTable === displayPricesTableType"
            [booking]="booking"
            [costOrRetail]="costOrRetail">
    </prices-table>
</div>
<tarification-details *ngIf="selectedPrice" [travellers]="booking?.travellerArray"
                      [price]="selectedPrice"
                      [booking]="booking"
                      [costOrRetail]="costOrRetail"></tarification-details>

